import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
// Components
import { ExpandMore, VisibilityOutlined, InsertDriveFileOutlined } from '@mui/icons-material';
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Button
} from '@mui/material';
import { IBuildOptionReport } from '../../models';

interface IBuildSelectedOptionsTableResponsiveComponent {
  original: IBuildOptionReport;
  setOpenPdfModal: (val: boolean) => void;
  setSelectedBuildReport: (val: IBuildOptionReport) => void;
}

export const BuildSelectedOptionsTableResponsiveComponent: FC<
  IBuildSelectedOptionsTableResponsiveComponent
> = ({ original, setOpenPdfModal, setSelectedBuildReport }) => {
  const classes = useStyles();
  const history = useHistory();
  const {
    neighborhoodName,
    lotNumber,
    buildSelectedOptionsPdfUrl,
    buildSelectedOptionsSlimPdfUrl
  } = original;

  const handleViewDetails = (page: IBuildOptionReport) => {
    history.push(`/documentation/build-selected-options/${page.neighborhoodId}/${page.lotNumber}`);
  };
  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">
            {neighborhoodName} - {lotNumber}
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Box
          marginTop="1rem"
          display="flex"
          flexDirection={{
            xs: 'column',
            sm: 'row'
          }}
        >
          <Button
            color="primary"
            startIcon={<VisibilityOutlined />}
            onClick={() => {
              handleViewDetails(original);
            }}
          >
            View Selected Options
          </Button>
          {(!!buildSelectedOptionsPdfUrl || !!buildSelectedOptionsSlimPdfUrl) && (
            <Button
              id={`pdf-modal-${original.neighborhoodId}-${original.lotNumber}`}
              color="secondary"
              startIcon={<InsertDriveFileOutlined />}
              onClick={() => {
                setSelectedBuildReport(original);
                setOpenPdfModal(true);
              }}
            >
              PDF
            </Button>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  approveButton: {
    padding: `2px 5px`
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  },
  activeName: {
    color: theme.palette.grey[500]
  },
  divider: {
    margin: '0 5px'
  },
  part: {
    flex: 1
  },
  statusRed: {
    color: theme.palette.error.main
  },
  tableCheckbox: {
    marginRight: 0
  }
}));
